import axios from 'axios';

export let cancelTokenSource = axios.CancelToken.source();
let tokens = [];
const instance = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_AUTH_URL,

});

instance.interceptors.request.use((config) => {
    const lang = localStorage.getItem("preferred-language") || 'fa'
    config.headers['x-lang'] = lang
    return config
  })

export const handleCancelRequest = (url = null) => {
    if (url == null) {
        tokens.forEach(el => {

            el.cancelTokenSource.cancel("Request was canceled");
            tokens.unshift()
        })
    }
    else {
        tokens.forEach(el => {
            if (el.config.url == url) {
                el.cancelTokenSource.cancel("Request was canceled");
                tokens.unshift()
            }

        })
    }
};


instance.interceptors.request.use(async function (config) {
    cancelTokenSource = axios.CancelToken.source();
    config.cancelToken = cancelTokenSource.token; //it will update cancelToken on every call
    tokens.push({ cancelTokenSource, config })
    return config;
});
export default instance;